@if (show) {
<script src="assets/scripts/task-loader-player.js"></script>
<div id="lottie" class="loader-overlay"></div>
<script src="assets/scripts/task-loader-script.js"></script>
}
